import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-prev-sq",
  "use": "icon-prev-sq-usage",
  "viewBox": "0 0 43 43",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 43 43\" id=\"icon-prev-sq\"><rect x=\"41.641\" y=\"41.644\" width=\"41.141\" height=\"41.141\" rx=\"1.5\" transform=\"rotate(-180 41.641 41.644)\" stroke=\"currentColor\" /><path d=\"M19.143 26.216a.908.908 0 0 0 1.485-.292.91.91 0 0 0-.199-.994l-2.932-2.933 9.36-.014a.91.91 0 0 0-.004-1.817l-9.384.008 2.955-2.955a.908.908 0 1 0-1.285-1.285l-4.498 4.498a.91.91 0 0 0 .004 1.286l4.498 4.498Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol